import ResourceCard from "./ResourceCard";

const ResourceList = ({ resources }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {resources.map((res) => (
        <ResourceCard key={res._id} resource={res} />
      ))}
    </div>
  );
};

export default ResourceList;
    